import { parseSubdomain } from './parseSubdomain'

export const getSubdomain = (location = window.location) => {
  const url = new URL(location)
  const params = url.searchParams
  return params.has('company')
    ? params.get('company')
    : parseSubdomain(url.hostname)
}
